export default __webpack_public_path__ + "static/media/management-courses1.e5ecce36.jpg";